import ContentLoader from 'react-content-loader';

function PizzaSkeleton() {
  return (
    <ContentLoader
      speed={2}
      width={280}
      height={500}
      viewBox="0 0 280 500"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      style={{ display: 'block', marginRight: 35 }}>
      <circle cx="134" cy="136" r="125" />
      <rect x="0" y="279" rx="10" ry="10" width="280" height="27" />
      <rect x="0" y="326" rx="10" ry="10" width="280" height="88" />
      <rect x="0" y="436" rx="10" ry="10" width="90" height="30" />
      <rect x="130" y="427" rx="25" ry="25" width="150" height="45" />
    </ContentLoader>
  );
}

export default PizzaSkeleton;
